<template>
	<div class="Cellhouseclass">
		<div><ReFilterBtn v-model="bShowFilter" :bShowOptsCount="false"/></div>
		<div class="col-md-12" v-show="bShowFilter">
			<ReFilter :masAllFilterParams="masAllFilterParams" 
			v-model="objGetParams" 
			v-on:filterapply="OnFilterApply"
			name="cellhouseclass"/>
		</div>
		
		<!--
		<div class="row px-3">		
			<card class="post mt-2 focus-shadow">
				<div class="pb-3">
					<h5><i class="tim-icons icon-send text-success mr-3"></i>Добавить дом</h5>
				</div>
				<div class="postAddForm">
					<ReFormPrinter :masFormConfig="masAllFormParams" :objSaveApiMethod="currentApiFormMethod" :SuccessGo="SuccessGo" SuccessBtnText="Добавить" />
				</div>
			</card>
		</div>
		-->

		<tabs type="primary"
            tabContentClasses="tab-opt"
			:activeTab="currentTab"
			@change="OnTabChange"
            centered
            inline
            round
			v-loading.fullscreen.lock="$GVO.fullscreenLoading"
			element-loading-text="Загрузка данных..."
			element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)"	
            class="card card-plain" 
		>
			<tab-pane :id="'table'">
				<span slot="label" class="tab-label">
					<i class="tab-icon tim-icons icon-align-left-2"></i>
					<span>Таблица</span>
				</span>	
				<card>
					<el-table ref="multipleTable" :data="ApiData" style="width: 100%">				
						<el-table-column
							width="80"
							label="ID"
							property="id"
						></el-table-column>
						
						<el-table-column 
							type="expand" 							
							sortable>
							<template v-slot="ApiData">
								<p>Квартир: {{ ApiData.row.living_places_count }}</p>
								<p>Год постройки: {{ ApiData.row.start_year }}</p>
								<p>Серия (тип дома): {{ ApiData.row.series_building }}</p>
								<p>Кадастровый номер: {{ ApiData.row.cadastr_number }}</p>
								<p>Количество этажей: {{ ApiData.row.floor_count }}</p>
								<p>Десткая площадка: {{ ApiData.row.playground }}</p>
								<p>Спортивная площадка: {{ ApiData.row.sportsground }}</p>
								<p>Признан аварийным: {{ ApiData.row.emergency }}</p>
								<p>Координаты: {{ ApiData.row.lat}}, {{ApiData.row.lng }}</p>
							
							</template>
						</el-table-column>

						<el-table-column
						sortable
						label="ХАРАКТЕРИСТИКА"
						min-width="200"
						prop="address">
						</el-table-column>

						<el-table-column
						label="КЛАСС ЖИЛЬЯ"
						prop="buildingClass"
						min-width="200"
						sortable>
							<template v-slot="scope">
							<el-select						
								class="col-md px-0 select-primary  overflow-overlay"						
								placeholder="Класс жилья"
								size="large"
								v-model="scope.row.cat_living_class_id"
							>
								<el-option
									class="select-primary long-select"
									v-for="option in masClasses"
									:key="option.label"
									:label="option.label"
									:value="option.value"
								>
								</el-option>
							</el-select>
							</template>
						</el-table-column>
						<!--el-table-column
						label="КООРДИНАТЫ"
						>
						<base-button type="primary" simple>Показать на карте</base-button>	
						</el-table-column-->
						<el-table-column
							width="170"
							label="Действие"
							align="right"                    	
						>
							<template v-slot="scope">	
								<el-tooltip content="Сохранить изменения" placement="top">
									<el-button class="no-border my-0">
										<base-button class="ml-3 btn btn-icon btn-simple btn-success" :key="scope.row.id" @click="SaveHouseClass(scope.row)">
											<i class="tim-icons icon-book-bookmark"></i>
										</base-button>											
									</el-button>
								</el-tooltip>			
								<!-- <el-tooltip content="История изменений" placement="top">
									<el-button class="no-border my-0">
										<button class="ml-3 btn btn-icon btn-simple btn-primary">
											<i class="d-inline-block tim-ic ic-history"></i>
										</button>											
									</el-button>
								</el-tooltip>			 -->
							</template>
						</el-table-column>
					</el-table>
					<Pagination :class="[{'': parseInt(masObjects_total) > 0}, {'d-none': parseInt(masObjects_total) < 1}]"
						:type="'info'" 
						:total="parseInt(masObjects_total)*parseInt(count2page)" 
						:perPage="parseInt(count2page)"
						:value="parseInt(typeof objGetParams.p == 'undefined' ? 1:objGetParams.p)"
						:pClick="pClick">
					</Pagination>
				</card>
			</tab-pane>
			<tab-pane :id="'map'">
				<span slot="label" class="tab-label">
					<i class="tab-icon tim-icons icon-square-pin"></i>
					<span>Карта</span>
				</span>				
				<card>	
					<div class="map-wrapper">	
						<!-- <h4>Классификация домов. Выберите дом на карте</h4>			 -->
						<div class="map mb-3" v-if="ApiMapData.length>0">
							<ReHouseClassMap :objData="ApiMapData"/>
						</div>
						<!-- <div class="row align-items-start">
							<div class="col">
								<p>Адрес: {{  }}</p>
								<p>Квартир: {{  }}</p>
								<p>Год постройки: {{  }}</p>
								<p>Серия (тип дома): {{  }}</p>
								<p>Кадастровый номер: {{  }}</p>
								<p>Количество этажей: {{  }}</p>
								<p>Десткая площадка: {{  }}</p>
								<p>Спортивная площадка: {{  }}</p>
								<p>Признан аварийным: {{  }}</p>
							</div>
							<div class="col">
								<div class="row align-items-center mx-0">
								<el-select						
								class="col-md px-0 select-primary  overflow-overlay"						
								placeholder="Класс жилья"
								size="large"
								v-model="valLivingClass"
								>
									<el-option
										class="select-primary long-select"
										v-for="option in masClasses"
										:key="option.label"
										:label="option.label"
										:value="option.value"
									>
									</el-option>
								</el-select>

								<el-tooltip content="Сохранить изменения" placement="top">
									<el-button class="no-border my-0">
										<base-button  class="ml-3 btn btn-simple btn-success" @click="SaveHouseClass()">
											<i class="tim-icons icon-book-bookmark"></i>
											Сохранить изменения
										</base-button>											
									</el-button>
								</el-tooltip>
								<el-tooltip content="История изменений" placement="top">
									<el-button class="no-border my-0">
										<base-button  class="ml-3 btn btn-simple btn-primary">
											<i class="d-inline-block tim-ic ic-history"></i>
											История изменений
										</base-button>											
									</el-button>
								</el-tooltip>			
									
								</div>
							</div>
						</div> -->
					</div>			
				</card>
				
			</tab-pane>
        </tabs>



	</div>
</template>
<script>

import {eventEmitter} from "src/plugins/globalComponents.js";
import { Table, TableColumn, Select, Option, Tooltip, Button } from 'element-ui';
import { TabPane, Tabs } from 'src/components';
// import ReInputSearchDropType from 'src/our_modules/SearchSendObjects/ReInputSearchDropType.vue';
// import ReInputRange from "src/our_components/ReInputRange.vue";
import ReFilterBtn from 'src/our_components/FilterPrinter/ReFilterBtn.vue';
import ReFilter from 'src/our_components/FilterPrinter/ReFilter.vue';
import ReHouseClassMap from 'src/our_components/ReHouseClassMap.vue';
import Pagination from 'src/our_components/RePagination';
// import ReFormPrinter from "src/our_components/FormPrinter/ReFormPrinter.vue";

export default {
	name: 'cellhouseclass-page',
	components: {
		[Table.name]: Table,
    	[TableColumn.name]: TableColumn,
		TabPane, 
		Tabs,
		[Option.name]: Option,
		[Select.name]: Select,
		[Tooltip.name]: Tooltip,	
		[Button.name]: Button,
		// ReInputSearchDropType,
		// ReInputRange,
		ReFilterBtn,
		ReFilter,
		ReHouseClassMap,
		Pagination,
		// ReFormPrinter
	},
	data() {
		return {
			ApiData: [],
			ApiMapData: [],
			bShowFilter: false,
			masAllFilterParams: this.currentFilterConfig(),
			currentApiFormMethod: this.currentApiFormMethodComp(),
			masAllFormParams: this.currentFormConfig(),
			masClasses: [],
			valLivingClass: '',
			masObjects_total: 0,
			count2page: 10,
			objGetParams:{},
			fullscreenLoading: false,
			currentTab:'table'
		};
	},
	methods: {
		currentFilterConfig(){
			this.$GVO.ApiCall('houses.GET_FILTER',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFilterParams = objApi.config;
						eventEmitter.$emit('OnFilterConfigLoad', this.masAllFilterParams);
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		currentApiFormMethodComp(){
			return {apiMethod:'houses.INSUPD',apiParam:{iData:[]}};
		},
		currentFormConfig() {
			//return require("src/conf/cellhouseclassForm.js").post_config;
			this.$GVO.ApiCall('houses.GET_FORM',{})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		getApiData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('houses.GET',{flt:{...{act:1}, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					this.ApiData = [];
					if(objApi.data.length > 0){
						this.ApiData = this.$GVO.unlinkObject(objApi.data);
						//console.log(objApi);
						this.masObjects_total = objApi.countpage;
						this.$refs.multipleTable.doLayout();
						// if(this.ApiData[i].valLivingClass == -1) this.ApiData[i].valLivingClass = '';
					}
				}else{
					this.ApiData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		getApiMapData(){
			this.objGetParams = this.$GVO.GetAllGet();
			let filter = {};
			if (!this.$GVO.isEmpty(this.objGetParams)) {
				//console.log('getClients',this.objGetParams);
				filter = this.objGetParams;
			}
			this.$GVO.ApiCall('houses.GET',{flt:{...{act:1, map:true}, ...filter}})
			.then((objApi) => {
				if(objApi.success === true){
					this.ApiMapData = [];
					if(objApi.data.length > 0){

						this.ApiMapData = this.$GVO.unlinkObject(objApi.data);
						//console.log(objApi);
						//this.masObjects_total = objApi.countpage;
						this.masObjects_total=0;
						// this.$refs.multipleTable.doLayout();
						// if(this.ApiMapData[i].valLivingClass == -1) this.ApiMapData[i].valLivingClass = '';
					}
				}else{
					this.ApiMapData = [];
					this.masObjects_total=0;
				}
			}).catch(errorObjApi => {this.ApiMapData = []; this.masObjects_total=0; console.error(errorObjApi);});
		},
		pClick(e){
			this.objGetParams['p'] = parseInt(e);
			this.OnFilterApply();
		},
		OnFilterApply(data){
			//console.log('OnFilterApply',data);
			//console.log('OnFilterApply',this.objGetParams);
			for (const key in this.objGetParams) {
				if (Object.hasOwnProperty.call(this.objGetParams, key)) {
					if(this.objGetParams[key] == '') delete this.objGetParams[key];
				}
			}
			let strItogGetParams = this.$GVO.ObjToQueryString(this.objGetParams).substr(1);
			//console.log('OnFilterApply',strItogGetParams,this.objGetParams);
			this.$router.push({path: location.pathname+'?'+strItogGetParams});
			eventEmitter.$emit('OnFilterApply', this.objGetParams);
			if(this.currentTab == 'map'){this.getApiMapData();}
			if(this.currentTab == 'table'){this.getApiData();}
		},
		SaveHouseClass(row){
			if(row.cat_living_class_id != null){
				let house_id = row.id;
				let house_class_id = row.cat_living_class_id;
				let house_class_name=this.$GVO.GetCatValName('cat_living_class', house_class_id);
				row.cat_living_class_name = house_class_name;

				this.$GVO.ApiCall('houses.UPD',{ flt:{id: house_id},uData:{'cat_living_class_name':house_class_name, 'cat_living_class_id':house_class_id }}) 
					.then((objApi) => {
						console.error(objApi);
						if(objApi.success === true){

						}else{
							alert('Не сохранилось');
						}
					}).catch(errorObjApi => {console.error(errorObjApi);});
			}
		},
		SuccessGo(evt,dopParam){
			// console.log(evt,dopParam);
			//тут надо написать опустошитель формы
		},	
		openFullScreen1(){
			this.fullscreenLoading = true;
			setTimeout(() => {
			this.fullscreenLoading = false;
			}, 2000);
		},
		OnTabChange(strTabId){
			this.currentTab = strTabId;
			this.$emit('input', strTabId);
			this.$emit('change', strTabId);
			this.openFullScreen1();
			// console.log(strTabId);
			if(strTabId == 'map'){this.getApiMapData();}
			if(strTabId == 'table'){this.getApiData();}
		},
	},
	mounted() {
		this.objGetParams = this.$GVO.GetAllGet();
		this.$GVO.LoadCatPromise('cat_living_class')
			.then((objApi) => {
				// console.log(this.$GVO.cats.cat_living_class);
				if(objApi=== true){
					this.masClasses = [];
					for (let i = 0; i < this.$GVO.cats.cat_living_class.length; i++) {
						const element = this.$GVO.unlinkObject(this.$GVO.cats.cat_living_class[i]);
						this.masClasses.push({value: element.id, label: element.name});
					}
					this.getApiData();
					// this.getApiMapData();
				}
			}).catch(errorObjApi => console.error(errorObjApi));
	}
};
</script>
<style>

.Cellhouseclass .cellmap-wrapper, .Cellhouseclass .map {
	width: 100%;	
	height: 100%;
}
.Cellhouseclass .cellmap {
	width: 100%;
	height: 100%;
	background: rgba(16, 33, 63, 0.986);
}
.Cellhouseclass .post {
	border: 1px solid transparent;
	border: 1px solid #01B0E0;
	border-radius: 0.2857rem;
	position: sticky;
	bottom: 0;		
}
.Cellhouseclass .post >>> .card-body {padding: 0px 5px 15px 10px!important;}
.Cellhouseclass .majorFilter-card {border: 1px solid #01b0e0;}
.Cellhouseclass .majorFilter {display: flex; }
.Cellhouseclass .firstFilter-row {display: flex; flex-wrap: wrap; width: 100%;}
.filter-shown {display: block;}
.filter-hidden {display: none;}
.Cellhouseclass .bntGroup {
	display: flex;
	justify-content: flex-end;
}
.Cellhouseclass .nav-pills .nav-item .nav-link {padding: 0px 20px;}
.Cellhouseclass .form-options-group{
	flex-direction: row;
	width: 100%;
	align-items: center;
	flex-wrap: wrap;
}
.Cellhouseclass .form-group {
	margin-bottom: 0px!important;
}
</style>
